import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import socialwork1 from '../Components/img/Socialwork/socialwork14.jpg'
import socialwork2 from '../Components/img/Socialwork/socialwork2.jpg'
import socialwork3 from '../Components/img/Socialwork/socialwork3.jpg'
import socialwork4 from '../Components/img/Socialwork/socialwork16.jpg'
import socialwork5 from '../Components/img/Socialwork/socialwork4.jpg'
import socialwork6 from '../Components/img/Socialwork/socialwork15.jpg'
import socialwork7 from '../Components/img/Socialwork/socialwork10.jpg'
import socialwork8 from '../Components/img/Socialwork/socialwork14.jpg'
import socialwork9 from '../Components/img/Socialwork/socialwork3.jpg'
import socialwork10 from '../Components/img/Socialwork/socialwork7.jpg'
import socialwork11 from '../Components/img/Socialwork/Socialwork27.jpg'
import socialwork12 from '../Components/img/Socialwork/socialwork21.jpg'
import socialwork13 from '../Components/img/Socialwork/socialwork12.jpg'
import socialwork14 from '../Components/img/Socialwork/socialwork25.jpg'
import socialwork15 from '../Components/img/Socialwork/socialwork23.jpg'
import socialwork26 from '../Components/img/Socialwork/new1.jpeg';
import socialwork16 from '../Components/img/Socialwork/new2.jpeg';
import socialwork17 from '../Components/img/Socialwork/new3.jpeg';
import socialwork18 from '../Components/img/Socialwork/new4.jpeg';
import socialwork19 from '../Components/img/Socialwork/new5.jpeg';
import socialwork20 from '../Components/img/Socialwork/new6.jpeg';
import socialwork21 from '../Components/img/Socialwork/new7.jpeg';
import socialwork22 from '../Components/img/Socialwork/new8.jpeg';
import socialwork23 from '../Components/img/Socialwork/new9.jpeg';
import socialwork24 from '../Components/img/Socialwork/new10.jpeg';
import socialwork25 from '../Components/img/Socialwork/new11.jpeg';
import socialworkW1 from '../Components/img/Socialwork/w1.jpeg'
import socialworkw2 from '../Components/img/Socialwork/w2.jpeg'
import socialworkw3 from '../Components/img/Socialwork/w3.jpeg'
import socialworkw4 from '../Components/img/Socialwork/WhatsApp Image 2026-01-09 at 2.44.48 PM.jpeg'
import socialworkw5 from '../Components/img/Socialwork/WhatsApp Image 2026-01-09 at 2.44.51 PM.jpeg'
import socialworkw6 from '../Components/img/Socialwork/WhatsApp Image 2026-01-09 at 2.44.53 PM.jpeg'
import socialworkw7 from '../Components/img/Socialwork/WhatsApp Image 2026-01-09 at 2.44.55 PM.jpeg'
import socialworkw8 from '../Components/img/Socialwork/WhatsApp Image 2026-01-09 at 2.44.57 PM.jpeg'

const Social_work = () => {
  return (
 <>
    <Container>
    <Row className='g-2 mb-3 img-fluids' >
    <Col xs={6} md={4} >
          <Image src={socialwork20} rounded  />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork2} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork3} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork4} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork5} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork6} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork7} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork8} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork9} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork10} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork11} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork12} rounded />
        </Col>
    </Row>
    <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork13} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork14} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork15} rounded />
        </Col>
    </Row>

       <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork16} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork21} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialworkW1} rounded />
        </Col>
    </Row>
       <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork22} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork19} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork24} rounded />
        </Col>
    </Row>
 
            <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork18} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork17} rounded />
        </Col>
        <Col xs={6} md={4}>
          <Image src={socialwork25} rounded />
        </Col>
    </Row>
          <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialworkw3} rounded />
        </Col>
       <Col xs={6} md={4} >
          <Image src={socialworkW1} rounded />
        </Col>
         <Col xs={6} md={4} >
          <Image src={socialworkw2} rounded />s
        </Col>
        
    </Row>
             <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialwork23} rounded />
        </Col>
       <Col xs={6} md={4} >
          <Image src={socialworkw5} rounded />
        </Col>
         <Col xs={6} md={4} >
          <Image src={socialworkw6} rounded />
        </Col>
        
    </Row>
     <Row className='g-2 mb-3'>
    <Col xs={6} md={4} >
          <Image src={socialworkw7} rounded />
        </Col>
       <Col xs={6} md={4} >
          <Image src={socialworkw8} rounded />
        </Col>
         <Col xs={6} md={4} >
          <Image src={socialworkw4} rounded />
        </Col>
        
    </Row>
  </Container>
 </>
  )
}


export default Social_work
